<template>
  <div class="fultServiceCenter-action">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" content="重新上报故障" />
    <ml-tip class="scroll-box" :showHeader="false" style="border: 0">
      <el-scrollbar :height="tabberHeight(185)">
        <!-- 表单 -->
        <ml-form
          ref="faultServiceCenterFormRef"
          labelWidth="200px"
          style="width: 1200px; margin: 20px auto 40px"
          :model="faultServiceCenterForm"
          :rules="faultServiceCenterFormRules"
        >
          <!-- 提示标题 -->
          <el-divider content-position="left" style="font-weight: bold">故障信息</el-divider>
          <el-row>
            <el-col :span="12">
              <ml-select
                prop="companyId"
                placeholder="请选择阿米巴"
                :options="unitOptions"
                label="阿米巴:"
                keyName="companyId"
                labelName="companyName"
                valueName="companyId"
                v-model="faultServiceCenterForm.companyId"
                @change="setCompany"
              />
            </el-col>
            <el-col :span="12">
              <!-- 所属项目 -->
              <ml-select
                prop="projectId"
                placeholder="请选择所属项目"
                :options="projectData"
                label="所属项目:"
                keyName="projectId"
                labelName="projectName"
                valueName="projectId"
                v-model="faultServiceCenterForm.projectId"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <ml-select
                prop="propertyType"
                placeholder="请选择资产类别"
                :options="propertyTypeList"
                label="资产类别:"
                keyName="label"
                labelName="label"
                valueName="label"
                v-model="faultServiceCenterForm.propertyType"
                @change="propertyTypeChange"
              />
            </el-col>
            <el-col :span="12">
              <ml-select
                prop="deviceType"
                placeholder="请选择设备类型"
                :options="deviceTypeList"
                label="设备类型:"
                keyName="label"
                labelName="label"
                valueName="label"
                v-model="faultServiceCenterForm.deviceType"
                @change="deviceTypeChange"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <ml-select
                prop="firstUnit"
                placeholder="请输入所属一级单位"
                :options="firstUnitList"
                label="所属一级单位:"
                keyName="label"
                labelName="label"
                valueName="label"
                v-model="faultServiceCenterForm.firstUnit"
                @change="searchfirstUnit"
              />
            </el-col>
            <el-col :span="12">
              <ml-select
                prop="secondUnit"
                placeholder="请输入所属二级单位"
                :options="secondUnitList"
                label="所属二级单位:"
                keyName="label"
                labelName="label"
                valueName="label"
                v-model="faultServiceCenterForm.secondUnit"
                @change="getEquipmentManageata"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <!-- 设备 -->
              <ml-select
                prop="deviceId"
                placeholder="请选择设备"
                :options="equipmentManageata"
                label="设备:"
                keyName="deviceId"
                labelName="deviceName"
                valueName="deviceId"
                v-model="faultServiceCenterForm.deviceId"
                v-model:node="deviceNode"
              />
            </el-col>
            <el-col :span="12">
              <ml-input
                prop="title"
                label="标题:"
                placeholder="请输入标题"
                v-model.trim="faultServiceCenterForm.title"
              />
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <ml-select
                prop="severity"
                placeholder="请选择严重程度"
                :options="severityData"
                label="严重程度:"
                labelName="label"
                valueName="label"
                v-model="faultServiceCenterForm.severity"
              />
            </el-col>
            <el-col :span="12">
              <ml-input
                prop="address"
                label="地点:"
                placeholder="请输入地点"
                v-model.trim="faultServiceCenterForm.address"
              />
            </el-col>
          </el-row>

          <ml-input
            prop="errorDesc"
            label="故障描述:"
            placeholder="请输入故障描述"
            type="textarea"
            :rows="5"
            v-model.trim="faultServiceCenterForm.errorDesc"
          />
          <el-form-item>
            <ml-list fileName="fileName" :list="faultServiceCenterForm.attachVos" />
          </el-form-item>

          <ml-button :showSubmit="false" :showCancel="false">
            <ml-upload
              multiple
              autoUpload
              :showFileList="false"
              :action="action"
              :data="{ linkType: 'error' }"
              :headers="{ Authorization: toKen }"
              name="files"
              @on-success="onSuccess"
            >
              <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary">
                上传附件
              </el-button>
            </ml-upload>
          </ml-button>

          <ml-button
            submitText="重新提交"
            submitIcon="el-icon-upload2"
            :showCancel="false"
            native-type="button"
            :disabledSubmit="disabledCancel"
            @click-submit="clickSubmitFultServiceCenter"
          >
            <el-button
              size="medium"
              icon="el-icon-circle-close"
              @click="clickCancelFultServiceCenter"
            >
              返回上一页
            </el-button>
          </ml-button>
        </ml-form>
      </el-scrollbar>
    </ml-tip>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getTabberData, tabberHeight, searchParams, getPropertyTypeList } from '@/utils'
import { BASEURL, FILEUPLOADURL } from '@API'

export default {
  name: 'FultServiceCenterActionReSubmit',
  setup() {
    const { commit, getters, dispatch } = useStore()
    const router = useRouter()
    const route = useRoute()
    const { errorId } = route.query
    const isBusinessDepartment = computed(() => getters.isBusinessDepartment)
    const toKen = computed(() => getters.getToken)
    /* 开始 表单 **********************************/
    // 详情数据
    const faultServiceCenterFormRef = ref()
    // 表单配置
    const faultServiceCenterForm = reactive({
      companyId: '',
      projectId: '',
      propertyType: '',
      deviceType: '',
      firstUnit: '',
      secondUnit: '',
      deviceId: '',
      title: '',
      severity: '',
      address: '',
      errorDesc: '',
      attachVos: [],
      signName: '',
      deviceName: '',
      province: '',
      city: '',
      area: '',
      latitude: '',
      longitude: ''
    })

    // 资产类型
    const propertyTypeList = ref(getPropertyTypeList())
    // 设备类型
    const deviceTypeList = ref([])
    const propertyTypeChange = () => {
      faultServiceCenterForm.deviceType = ''
      faultServiceCenterForm.deviceId = ''
      faultServiceCenterForm.firstUnit = ''
      faultServiceCenterForm.secondUnit = ''
      secondUnitList.value = []
      fetchgetfirstUnitList()
      getEquipmentManageata()
    }
    // 监听资产类型变化
    watch(
      () => faultServiceCenterForm.propertyType,
      newvalue => {
        deviceTypeList.value = []
        if (newvalue) {
          const newPropertyTypeList = propertyTypeList.value.filter(item => item.label === newvalue)
          deviceTypeList.value = newPropertyTypeList[0].value
        }
      }
    )

    const searchfirstUnit = () => {
      faultServiceCenterForm.secondUnit = ''
      getEquipmentManageata()
    }

    watch(
      () => faultServiceCenterForm.firstUnit,
      () => {
        fetchgetsecondUnitList()
      }
    )

    const deviceTypeChange = () => {
      faultServiceCenterForm.deviceId = ''
      faultServiceCenterForm.firstUnit = ''
      faultServiceCenterForm.secondUnit = ''
      fetchgetfirstUnitList()
      getEquipmentManageata()
    }
    // 一级单位
    const fetchgetfirstUnitList = () => {
      const { companyId, projectId, propertyType, deviceType } = faultServiceCenterForm
      const firstUnitParams = {
        projectId,
        companyId
      }
      if (propertyType) {
        firstUnitParams.propertyType = propertyType
      }
      if (deviceType) {
        firstUnitParams.deviceType = deviceType
      }
      dispatch('fetchgetfirstUnitList', firstUnitParams).then(data => {
        if (data && data.code === 200) {
          if (data.data && data.data.length > 0) {
            firstUnitList.value = data.data.map(item => {
              return {
                label: item
              }
            })
          } else {
            firstUnitList.value = []
          }
        }
      })
    }
    // 一级单位
    const fetchgetsecondUnitList = () => {
      const { companyId, projectId, propertyType, deviceType, firstUnit } = faultServiceCenterForm
      const secondUnitParams = {
        projectId,
        companyId,
        propertyType,
        deviceType,
        firstUnit
      }

      dispatch('fetchgetsecondUnitList', secondUnitParams).then(data => {
        if (data && data.code === 200) {
          if (data.data && data.data.length > 0) {
            secondUnitList.value = data.data.map(item => {
              return {
                label: item
              }
            })
          } else {
            secondUnitList.value = []
          }
        }
      })
    }

    // 类型下拉列表
    const typeData = ref([{ label: '故障' }, { label: '缺陷' }])
    // 严重程度下拉列表
    const severityData = ref([
      { label: '轻微' },
      { label: '一般' },
      { label: '严重' },
      { label: '灾难' }
    ])
    // 单位名下拉列表
    const unitOptions = ref([])
    // 设备选中信息
    const deviceNode = ref({})
    // 所属项目下拉列表
    const projectData = ref([])
    // 一级单位
    const firstUnitList = ref([])
    // 二级单位
    const secondUnitList = ref([])
    // 设备下拉列表
    const equipmentManageata = ref([])
    // 处理所属项目
    const getProjectData = async companyId => {
      const projectParams = {}
      if (isBusinessDepartment.value) {
        projectParams.companyId = companyId
      }
      const { data } = await getTabberData(dispatch, 'fetchGetProjectsByCompany', projectParams)
      projectData.value = data || []
    }
    const setCompany = () => {
      faultServiceCenterForm.projectId = ''
      faultServiceCenterForm.deviceId = ''
    }
    // 处理设备
    const getEquipmentManageata = async () => {
      const {
        companyId,
        projectId,
        propertyType,
        deviceType,
        firstUnit,
        secondUnit
      } = faultServiceCenterForm
      const projectParams = {
        projectId,
        companyId
      }
      if (propertyType) {
        projectParams.propertyType = propertyType
      }
      if (deviceType) {
        projectParams.deviceType = deviceType
      }
      if (firstUnit) {
        projectParams.firstUnit = firstUnit
      }
      if (secondUnit) {
        projectParams.secondUnit = secondUnit
      }
      const { data } = await getTabberData(dispatch, 'fetchGetDeviceInfos', projectParams)
      equipmentManageata.value = data || []
    }
    // 监听项目
    const searchProject = () => {
      faultServiceCenterForm.propertyType = ''
      faultServiceCenterForm.deviceType = ''
      faultServiceCenterForm.deviceId = ''
      fetchgetfirstUnitList()
      getEquipmentManageata()
    }
    // 监听单位
    watch(
      () => faultServiceCenterForm.companyId,
      newvalue => {
        getProjectData(newvalue)
      }
    )
    // 监听设备
    watch(
      () => deviceNode.value,
      newvalue => {
        const {
          deviceName,
          province,
          city,
          area,
          latitude,
          longitude,
          address,
          propertyType,
          deviceType,
          firstUnit,
          secondUnit
        } = newvalue
        faultServiceCenterForm.deviceName = deviceName
        faultServiceCenterForm.province = province
        faultServiceCenterForm.propertyType = propertyType
        faultServiceCenterForm.deviceType = deviceType
        faultServiceCenterForm.firstUnit = firstUnit
        faultServiceCenterForm.secondUnit = secondUnit
        faultServiceCenterForm.city = city
        faultServiceCenterForm.area = area
        faultServiceCenterForm.latitude = latitude
        faultServiceCenterForm.longitude = longitude
        faultServiceCenterForm.address = address
      }
    )

    // 表单校验
    const faultServiceCenterFormRules = {
      companyId: [{ required: true, message: '请选择阿米巴 ', trigger: 'blur' }],
      projectId: [{ required: true, message: '请选择所属项目', trigger: 'blur' }],
      deviceId: [{ required: true, message: '请选择设备', trigger: 'blur' }],
      title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
      severity: [{ required: true, message: '请选择严重程度', trigger: 'blur' }],
      address: [{ required: true, message: '请输入地址', trigger: 'blur' }]
    }
    // 提交表单
    const disabledCancel = ref(false)
    const clickSubmitFultServiceCenter = () => {
      // deviceErrorDraft
      faultServiceCenterFormRef.value.CustomFormRef.validate()
        .then(() => {
          disabledCancel.value = true
          const faultServiceCenterParams = searchParams(faultServiceCenterForm, [
            'firstUnit',
            'secondUnit'
          ])
          faultServiceCenterParams.deviceInfo = {}
          const { firstUnit, secondUnit } = faultServiceCenterForm
          if (firstUnit) {
            faultServiceCenterParams.deviceInfo.firstUnit = firstUnit
          }
          if (secondUnit) {
            faultServiceCenterParams.deviceInfo.secondUnit = secondUnit
          }
          faultServiceCenterParams.errorId = errorId
          dispatch('fetchGetRepeatSubmitErrorRecord', faultServiceCenterParams).then(data => {
            if (data && data.code === 200) {
              commit('setError', {
                status: true,
                title: data.message,
                message: '正在获取新的数据...',
                type: 'success'
              })
              disabledCancel.value = false
              router.push({ path: '/faultServiceCenter' })
            }
          })
        })
        .catch(() => {})
    }
    // 取消表单
    const clickCancelFultServiceCenter = () => {
      router.push({ path: '/faultServiceCenter' })
    }

    const getFaultServiceCenterDetails = async () => {
      // 查看故障详情
      await dispatch('fetchGetDeviceErrorRecord', errorId).then(data => {
        if (data && data.code === 200 && data.data) {
          const { firstUnit, secondUnit } = data.data
          Object.keys(faultServiceCenterForm).map(item => {
            if (['attachVos'].includes(item)) {
              faultServiceCenterForm[item] = data.data[item] || []
            } else if (['firstUnit'].includes(item)) {
              faultServiceCenterForm[item] = firstUnit
            } else if (['secondUnit'].includes(item)) {
              faultServiceCenterForm[item] = secondUnit
            } else {
              faultServiceCenterForm[item] = data.data[item]
            }
          })
        }
      })
    }

    // 上传附件
    const action = ref(`${BASEURL}${FILEUPLOADURL}`)
    const onSuccess = files => {
      if (files.data) {
        faultServiceCenterForm.attachVos = [...faultServiceCenterForm.attachVos, ...files.data]
      }
    }

    /* 结束 用户表单 **********************************/
    onMounted(async () => {
      // 获取单位名
      const { data } = await getTabberData(dispatch, 'fetchGetCompanyInfos', {
        noCompanyCode: 'business_department'
      })
      unitOptions.value = data || []
      if (data.length > 0) {
        faultServiceCenterForm.companyId = data[0].companyId
      }
      await getFaultServiceCenterDetails()
    })
    return {
      faultServiceCenterForm,
      unitOptions,
      projectData,
      faultServiceCenterFormRules,
      clickSubmitFultServiceCenter,
      clickCancelFultServiceCenter,
      tabberHeight,
      faultServiceCenterFormRef,
      setCompany,
      equipmentManageata,
      typeData,
      severityData,
      onSuccess,
      action,
      toKen,
      deviceNode,
      disabledCancel,
      propertyTypeList,
      deviceTypeList,
      propertyTypeChange,
      deviceTypeChange,
      firstUnitList,
      secondUnitList,
      searchProject,
      getEquipmentManageata,
      searchfirstUnit
    }
  }
}
</script>

<style lang="scss">
.fultServiceCenter-action {
  position: relative;
}
</style>
